class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.languageInput = this.querySelector('[data-marri-language-input]');
    this.countryInput = this.querySelector('[data-marri-country-input]');
    this.buttons = this.querySelectorAll('[data-language-code]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.submitSelection(button));
    });
  }

  submitSelection(button) {
    if (!this.form || button.disabled) return;

    const languageCode = button.dataset.languageCode;
    const countryCode = button.dataset.countryCode;

    if (this.languageInput && languageCode) this.languageInput.value = languageCode;
    if (this.countryInput && countryCode) this.countryInput.value = countryCode;

    button.setAttribute('aria-busy', 'true');
    this.form.submit();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-marri-language-selector]');
  if (!drawer || drawer.dataset.marriAccessibilityReady === 'true') return;
  drawer.dataset.marriAccessibilityReady = 'true';

  const dialog = drawer.querySelector('.main_localization_inner');
  const closeButton = drawer.querySelector('.localization_close');
  const selectors = document.querySelectorAll('.localization_selectors');
  let lastTrigger = null;

  const getFocusable = () => Array.from(
    drawer.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
  );

  const closeDrawer = () => {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    selectors.forEach((selector) => selector.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('marri-localization-open');
    lastTrigger?.focus();
  };

  selectors.forEach((selector) => {
    selector.addEventListener('click', () => {
      lastTrigger = selector;
      document.body.classList.add('marri-localization-open');
      window.setTimeout(() => closeButton?.focus(), 0);
    });
  });

  closeButton?.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });
  dialog?.addEventListener('click', (event) => event.stopPropagation());

  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
});
